import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import DeveloperStateDisplay from "@components/Displays/DeveloperStateDisplay";
import { YesNoColumn } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function DeveloperListScreen() {
    return (
        <DefaultLayout>
            <DeveloperList />
        </DefaultLayout>
    );
}

function DeveloperList() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:developer:list"));
    const commonInfo = useRouteLoaderData("commonInfo");

    if (!apiData) return;

    return (
        <ListingCard header={t("Компании")}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Название")}</th>
                        <th>{t("Email для связи")}</th>
                        <th>{t("Состояние")}</th>
                        <th>{t("Витрина ")}</th>
                        {commonInfo.account.is_super && (
                            <>
                                <th>Slug</th>
                                <th>{t("Количество ГБ на проект")}</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => (
                        <tr key={`object_list${i}`}>
                            <td>
                                <Link to={url_reverse("devs:edit", { dev_id: o.id })}>{o.name}</Link>
                            </td>
                            {/* Показывать только первый email */}
                            <td>{o.contact_email.split(",")[0]}</td>
                            <td>
                                <DeveloperStateDisplay developer={o} />
                            </td>
                            <td>
                                <YesNoColumn attr={apiData.published_developers_vkplay?.includes(o.id)} />
                            </td>
                            {commonInfo.account.is_super && (
                                <>
                                    <td>{o.slug}</td>
                                    <td>{o.quota_size}</td>
                                </>
                            )}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}
